export default {
  title: "hello es",
  "common-retry": "Reintentar",
  "assessment-provision-failed": "No se pudo preparar el entorno de práctica.\nVuelve a intentarlo o contacta con soporte si el problema continúa.",
  "skillCertify-provision-preparing": "Preparando el entorno de evaluación",
  "skillCertify-provision-checking": "Verificando entorno...",
  "skillCertify-provision-ready": "Listo",
  "skillCertify-provision-starting": "Iniciando...",
  "skillCertify-provision-estimated-wait": "Tiempo de espera estimado: ~{min} min",
  "skillCertify-command-basic-proctoring-label": "Basic Proctoring",
  "skillCertify-command-advanced-proctoring-label": "Advanced Proctoring",
  page: {
    learning: {}
  },
  components: {
    "code-editor": {
      "hint-widget": {
        "hint-button-title": "Click here for a hint."
      },
    },
    common: {
      dialog: {
        Cookie: {
          "cookie-accept": {
            title: "Accept Cookies",
            content: {
              first: "This website uses performance cookies to analyze traffic and to help us provide you with the best experience we can.",
              second: "By clicking “Accept All”, you agree Codepresso can store cookies on your device and disclose information in accordance with our "
            },
            buttons: {
              necessary: "Reject All",
              accept: "Accept All"
            }
          },
          "cookie-manage": {
            title: "Cookie Preferences",
            tap: {
              "tap-0": "Strictly Necessary",
              "tap-1": "Performance"
            },
            "sub-title": {
              "sub-title-0": "Strictly Necessary Cookies",
              "sub-title-1": "Performance Cookies",
              "sub-button": "Always Active"
            },
            content: {
              "content-0":
                "These cookies are necessary for our website to function properly and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms or where they’re essential to provide you with a service you have requested. You cannot opt-out of these cookies. You can set your browser to block or alert you about these cookies, but if you do, some parts of the site will not then work. These cookies do not store any personally identifiable information.",
              "content-1":
                "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site, which helps us optimize your experience. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not be able to use your data in this way.<a href=\"/policy?policy=cookie#cookie-types-performance\">Cookie details.</a>"
            },
            buttons: {
              confirm: "Save",
              accept: "Accept All"
            }
          }
        }
      }
    }
  }
};
